import PropTypes from 'prop-types'
import React from 'react'
import { Body, CardWrapper, CenterElement, H4, Header } from './theme'

const Card = ({ header, children, maxWidth }) => (
  <CardWrapper maxWidth={maxWidth}>
    <Header>
      <H4>{header}</H4>
    </Header>
    <Body>{children}</Body>
  </CardWrapper>
)

Card.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  maxWidth: PropTypes.string,
}

export default Card
export { CenterElement }



// WEBPACK FOOTER //
// ./src/components/Card/index.js